import axios from "axios";

// Resolve the API base at runtime.
// If the build-time REACT_APP_BACKEND_URL points to a different host than the
// browser is currently on (e.g. a production deploy still baked with the preview
// URL), fall back to same-origin — Emergent's ingress routes /api to backend on
// both preview and production hosts.
function resolveApiBase() {
  const envUrl = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window !== "undefined" && window.location) {
    try {
      const envHost = envUrl ? new URL(envUrl).host : "";
      if (!envHost || envHost !== window.location.host) {
        return `${window.location.origin}/api`;
      }
    } catch {
      return `${window.location.origin}/api`;
    }
  }
  return `${envUrl}/api`;
}

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = resolveApiBase();

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token from localStorage as fallback for cross-origin cookie edge cases
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("dw_token");
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return String(detail);
}

export default api;
